import React, { useState, useEffect } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import "focus-visible/dist/focus-visible";
import { AuthProvider, useAuth } from "@/lib/auth";
//import "../styles/grid.css";
import "../styles/global.css";
import "../styles/custom.css";
import "react-datepicker/dist/react-datepicker.css";
import "../styles/hightlight.css";
import "../styles/date-picker.css";
import Header from "@/components/templates/Header";
import Footer from "@/components/templates/Footer";
import { GoogleOAuthProvider } from "@react-oauth/google";
import toast, { Toaster } from "react-hot-toast";
import { Provider, useSelector } from "react-redux";
import store from '../store/index';
import { fetchIndustries, fetchServices, fetchCareers, fetchSkills, getUser, getUsers, manageDisputes, manageSessions, userLogout } from "store/authSlice";
import firebase from "firebase";
import { useRouter } from "next/router";
import { updateSessionStatusByFirebase } from "@/lib/db";
import useCustomToast from "hooks/useCustomToast";
import { jwtDecode } from "jwt-decode";
const ClientApp = ({ Component, pageProps }) => {
  const firestore = firebase.firestore();
  const db = firestore;
  const toast = useCustomToast();
  const { user } = useSelector((state) => state.auth);
  const router = useRouter();
  useEffect(() => {
    let token = localStorage.getItem('token');
    if (token && (token !== 'undefined')) {
      const { exp } = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (exp < currentTime) {
        userLogout(store.dispatch, router);
        toast("Your session has expired. Please log in again.", "error", '', true);
      }
    }
  })
  useEffect(() => {
    store.dispatch(fetchIndustries({ page: 1, limit: 50, search: null }));
    store.dispatch(fetchServices({ page: 1, limit: 50, search: null }));
    store.dispatch(fetchCareers({ page: 1, limit: 50, search: null }));
    store.dispatch(fetchSkills({ page: 1, limit: 50, search: null }));
  }, []);

  useEffect(() => {
    const unsubscribe = db.collection("listProfileUpdate").onSnapshot(
      (snapshot) => {
        const updatedData = snapshot.docs.map((doc) => ({
          ...doc.data(),
        }));
        if (user && updatedData[0]?.logout === user?._id) {
          userLogout(store.dispatch, router);
          toast("Your session has expired. Please log in again.", "error", '', true);
        }
        if (updatedData[0]?.update) {
          if (user) {
            store.dispatch(getUser({ id: user?._id }));
          }

          if (router?.query?.sessionId || router?.query?.projectId) {
            store.dispatch(manageSessions({ method: "get", id: router?.query?.sessionId || router?.query?.projectId }));
          }
          if (!router?.query?.sessionId && !router?.query?.projectId) {
            store.dispatch(manageSessions({ method: "get" }));
          }
        }
        if (updatedData[0]?.disputes) {
          store.dispatch(manageDisputes({ method: "get", id: user?.role !== 'owner' ? user?._id : null }));
        }
        updateSessionStatusByFirebase(false, false, null);
      },
      (error) => {
        console.error("Error fetching sessions:", error);
      }
    );

    return () => unsubscribe();
  }, [user, router]);

  return (
    <>
      <Header />
      <Component {...pageProps} />
      <Footer />
    </>
  );
};
const App = ({ Component, pageProps }) => {
  const CLIENT_ID = "691895213501-ee0lk258nt1d05oou0muo33hjvbucu30.apps.googleusercontent.com";

  return (
    <Provider store={store}>
      <ChakraProvider>
        {/* <GoogleOAuthProvider clientId={CLIENT_ID}> */}
        <Toaster position="top-right" reverseOrder={false} />
        <AuthProvider>
          <ClientApp Component={Component} pageProps={pageProps} />
        </AuthProvider>
        {/* </GoogleOAuthProvider> */}
      </ChakraProvider>
    </Provider>
  );
};

export default App;
